(createjs.Filter.prototype as any).equals = function (this: createjs.Filter, filter: createjs.Filter) {
    return filter instanceof createjs.Filter && filter.constructor.name === this.constructor.name;
};
(createjs.BlurFilter.prototype as any).equals = function (this: createjs.BlurFilter, filter: createjs.Filter) {
    if (!(filter instanceof createjs.BlurFilter)) { return false; }
    return this.blurX === filter.blurX && this.blurY === filter.blurY && this.quality === filter.quality;
};

(createjs.ColorFilter.prototype as any).equals = function (this: createjs.ColorFilter, filter: createjs.Filter) {
    if (!(filter instanceof createjs.ColorFilter)) { return false; }
    return this.alphaMultiplier === filter.alphaMultiplier && this.alphaOffset === filter.alphaOffset &&
        this.blueMultiplier === filter.blueMultiplier && this.blueOffset === filter.blueOffset &&
        this.greenMultiplier === filter.greenMultiplier && this.greenOffset === filter.greenOffset &&
        this.redMultiplier === filter.redMultiplier && this.redOffset === filter.redOffset;
};

(createjs.ColorMatrixFilter.prototype as any).equals = function (this: createjs.ColorMatrixFilter, filter: createjs.Filter) {
    if (!(filter instanceof createjs.ColorMatrixFilter)) { return false; }
    if (!(this.matrix instanceof createjs.ColorMatrix) && !(filter.matrix instanceof createjs.ColorMatrix)) {
        for (let i = 0; i < this.matrix.length; i++) {
            if (this.matrix[i] !== filter.matrix[i]) {
                return false;
            }
        }
        return true;
    } else {
        return false;
    }
};

(createjs.AlphaMapFilter.prototype as any).equals = function (this: createjs.AlphaMapFilter, filter: createjs.Filter) {
    return false;
};

(createjs.AlphaMaskFilter.prototype as any).equals = function (this: createjs.AlphaMaskFilter, filter: createjs.Filter) {
    return false;
};

(createjs.DropShadowFilter.prototype as any).equals = function (this: createjs.DropShadowFilter, filter: createjs.Filter) {
    if (!(filter instanceof createjs.DropShadowFilter)) { return false; }
    return this.angle === filter.angle && this.blurX === filter.blurX && this.blurY === filter.blurY &&
        this.color === filter.color && this.quality === filter.quality && this.distance === filter.distance;
};

(createjs.GlowFilter.prototype as any).equals = function (this: createjs.GlowFilter, filter: createjs.Filter) {
    if (!(filter instanceof createjs.GlowFilter)) { return false; }
    return this.strength === filter.strength && this.blurX === filter.blurX && this.blurY === filter.blurY &&
        this.color === filter.color && this.quality === filter.quality;
};

Object.defineProperty(createjs.Filter.prototype, "isScaled", {
    value: false,
    enumerable: true,
    configurable: true,
    writable: true
});